import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { storeWithExpiration } from '../../utils/common';
import {
  EDIT_GROUP_PAGE,
  EDIT_SKU_PAGE,
  FIELDSET_TYPE_GROUP,
  RECORD_LEVEL_TYPE_COMPANY,
  RECORD_LEVEL_TYPE_CONTACT,
  RECORD_LEVEL_TYPE_ITEM,
} from '../../config/app_config';
import DialogForm from '../shared/DialogForm';

let ALL_FIELDS_MAP = new Map();
let SKU_FIELDS_MAP = new Map();
let COMPANY_SKU_FIELDS_MAP = new Map();
let CONTACT_SKU_FIELDS_MAP = new Map();
let ITEM_SKU_FIELDS_MAP = new Map();

export default class PreviewSkuDialog extends React.Component {
  static propTypes = {
    clearFieldsForSkuFunction: PropTypes.func.isRequired,
    closeDialogFunction: PropTypes.func.isRequired,
    currentFilesets: PropTypes.object,
    currentSku: PropTypes.object.isRequired,
    currentSkuFields: PropTypes.object.isRequired,
    datasetFields: PropTypes.object.isRequired,
    datasetId: PropTypes.number.isRequired,
    datasetState: PropTypes.string.isRequired,
    dialog: PropTypes.object.isRequired,
    getFieldsForSkuFunction: PropTypes.func.isRequired,
    goToEditFieldsetFunction: PropTypes.func.isRequired,
    isAdminPage: PropTypes.bool.isRequired,
    listFieldsFunction: PropTypes.func.isRequired,
    permissionToEdit: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    currentFilesets: null,
  };

  componentWillMount = () => {
    const {
      listFieldsFunction,
      getFieldsForSkuFunction,
      datasetId,
      currentSku,
      clearFieldsForSkuFunction,
    } = this.props;
    const prom = new Promise(resolve => {
      clearFieldsForSkuFunction(resolve);
    });
    prom.then(() => {
      listFieldsFunction(datasetId, storeWithExpiration.get('token'), () => false).then(() => {
        getFieldsForSkuFunction(storeWithExpiration.get('token'), currentSku.id, datasetId);
      });
    });
  };

  componentWillReceiveProps = nextProps => {
    ALL_FIELDS_MAP = new Map();
    SKU_FIELDS_MAP = new Map();
    COMPANY_SKU_FIELDS_MAP = new Map();
    CONTACT_SKU_FIELDS_MAP = new Map();
    ITEM_SKU_FIELDS_MAP = new Map();

    if (nextProps.currentSkuFields.size > 0 && nextProps.datasetFields.size > 0) {
      nextProps.datasetFields.map(field => {
        ALL_FIELDS_MAP = ALL_FIELDS_MAP.set(field.id, field);
        return ALL_FIELDS_MAP;
      });

      nextProps.currentSkuFields.map(field => {
        if (ALL_FIELDS_MAP.get(field.get('fieldId')) !== undefined) {
          SKU_FIELDS_MAP = SKU_FIELDS_MAP.set(
            field.get('fieldId'),
            ALL_FIELDS_MAP.get(field.get('fieldId'))
          );
        }
        return SKU_FIELDS_MAP;
      });

      SKU_FIELDS_MAP.map(field => {
        const filesetId = field.get('filesetId');
        const fileSet = nextProps.currentFilesets.get(`${filesetId}`);
        let recordLevelType = '';

        if (fileSet) {
          recordLevelType = fileSet.get('recordLevelType');
        }

        if (recordLevelType === RECORD_LEVEL_TYPE_COMPANY) {
          COMPANY_SKU_FIELDS_MAP = COMPANY_SKU_FIELDS_MAP.set(field.get('id'), field);
        } else if (recordLevelType === RECORD_LEVEL_TYPE_CONTACT) {
          CONTACT_SKU_FIELDS_MAP = CONTACT_SKU_FIELDS_MAP.set(field.get('id'), field);
        } else if (recordLevelType === RECORD_LEVEL_TYPE_ITEM) {
          ITEM_SKU_FIELDS_MAP = ITEM_SKU_FIELDS_MAP.set(field.get('id'), field);
        }
        return SKU_FIELDS_MAP;
      });
    }
  };

  groupAdvancedParams = (trimmedParams, grouptType) => {
    const mappedGroups = trimmedParams.groupBy(
      param => (param[grouptType] !== null ? param[grouptType] : 'None')
    );
    return mappedGroups;
  };

  filterAdvanced = datasetFields => datasetFields.filter(field => !field.isSimpleSearch);

  filterSimple = datasetFields => datasetFields.filter(field => field.isSimpleSearch);

  goToEditPage = page => {
    const {
      currentSku,
      datasetId,
      goToEditFieldsetFunction,
      isAdminPage,
      closeDialogFunction,
    } = this.props;
    goToEditFieldsetFunction(currentSku.id, datasetId, page, isAdminPage);
    closeDialogFunction('PreviewSkuDialog');
  };

  handleJumpToContacts = () => {
    this.contactTable.scrollIntoView();
  };

  handleJumpToCompanies = () => {
    this.companyTable.scrollIntoView();
  };

  renderPreview = () => {
    const { currentSku, datasetState, isAdminPage, permissionToEdit } = this.props;
    let subTitlePrefix = 'SKU Preview:';
    let editButtonTitle = 'Edit SKU';
    let isGroup = false;

    // Set up titles if we're previewing a group
    if (currentSku.setType === FIELDSET_TYPE_GROUP) {
      subTitlePrefix = 'Group Preview:';
      editButtonTitle = 'Edit Group';
      isGroup = true;
    }

    return (
      <div className="pre-scrollable sku-preview">
        <div className="container">
          <p>
            {subTitlePrefix} {currentSku.name}
            {permissionToEdit ? (
              <span className="pull-right">
                {currentSku.installedCount > 0 ? (
                  'This SKU is in use and cannot be edited'
                ) : (
                  <button
                    className="btn btn-primary"
                    disabled={!isAdminPage && datasetState !== 'APPROVED'}
                    onClick={() =>
                      isGroup
                        ? this.goToEditPage(EDIT_GROUP_PAGE)
                        : this.goToEditPage(EDIT_SKU_PAGE)
                    }
                  >
                    {editButtonTitle}
                  </button>
                )}
              </span>
            ) : null}
          </p>
          <br />
          {COMPANY_SKU_FIELDS_MAP.size > 0 ? this.renderFields(RECORD_LEVEL_TYPE_COMPANY) : null}
          {CONTACT_SKU_FIELDS_MAP.size > 0 ? this.renderFields(RECORD_LEVEL_TYPE_CONTACT) : null}
          {ITEM_SKU_FIELDS_MAP.size > 0 ? this.renderFields(RECORD_LEVEL_TYPE_ITEM) : null}
        </div>
      </div>
    );
  };

  renderAdvancedFieldGroups = fieldGroups => {
    const groupsArray = [];
    // Render ungrouped table first
    fieldGroups.forEach((values, key) => {
      if (key === 'None') {
        const groupKey = `group-${key}`;
        groupsArray.push(
          <div className="col-xs-12" key={groupKey}>
            <div className="row">{this.renderTable(values)}</div>
          </div>
        );
      }
    });
    // Then render grouped table
    fieldGroups.forEach((values, key) => {
      if (key !== 'None') {
        const groupKey = `group-${key}`;
        groupsArray.push(
          <div className="col-xs-12" key={groupKey}>
            <div>{key !== 'None' ? <h4>{key}</h4> : <h4>Other Parameters</h4>}</div>
            <div>
              <div className="row">{this.renderTable(values)}</div>
            </div>
          </div>
        );
      }
    });
    return groupsArray;
  };

  renderAdvancedDisplayGroups = advancedGroups => {
    const displayGroupsArray = [];
    let groupedAdvancedFields = null;
    // Render ungrouped params first
    advancedGroups.forEach((values, key) => {
      if (key === 'None') {
        const groupKey = `group-${key}`;
        groupedAdvancedFields = this.groupAdvancedParams(values, 'selectionGroup');
        displayGroupsArray.push(
          <div className="param-group" key={groupKey}>
            <div className="card">
              <div className="card-header">
                <span>General</span>
              </div>
              <div className="card-block">
                <div className="row">{this.renderAdvancedFieldGroups(groupedAdvancedFields)}</div>
              </div>
            </div>
          </div>
        );
      }
    });
    // Then render grouped params
    advancedGroups.forEach((values, key) => {
      if (key !== 'None') {
        const groupKey = `group-${key}`;
        groupedAdvancedFields = this.groupAdvancedParams(values, 'selectionGroup');
        displayGroupsArray.push(
          <div className="param-group" key={groupKey}>
            <div className="card">
              <div className="card-header">
                {key !== 'None' ? <span>{key}</span> : <span>Other Parameters</span>}
              </div>
              <div className="card-block">
                <div className="row">{this.renderAdvancedFieldGroups(groupedAdvancedFields)}</div>
              </div>
            </div>
          </div>
        );
      }
    });
    return displayGroupsArray;
  };

  renderTable = (fieldsMap, header = null) => (
    <div className="col-xs-12">
      {header ? <h4>{header}</h4> : null}
      <table className="table table-sm">
        <thead>
          <tr>
            <th>Display Name</th>
            <th>Field Name</th>
          </tr>
        </thead>
        <tbody>
          {fieldsMap.valueSeq().map(field => (
            <tr key={field.id}>
              <td>{field.description}</td>
              <td>{field.name}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  renderFields = type => {
    const showButton =
      (CONTACT_SKU_FIELDS_MAP.size > 0 && COMPANY_SKU_FIELDS_MAP.size > 0) || false;
    let SIMPLE_FIELDS_MAP = null;
    let ADVANCED_FIELDS_MAP = null;
    let tableRef = '';
    let tableHeader = '';
    let buttonName = '';
    let jumpToFunction = null;

    switch (type) {
      case RECORD_LEVEL_TYPE_COMPANY:
        SIMPLE_FIELDS_MAP = this.filterSimple(COMPANY_SKU_FIELDS_MAP);
        ADVANCED_FIELDS_MAP = this.filterAdvanced(COMPANY_SKU_FIELDS_MAP);
        tableRef = 'companyTable';
        tableHeader = 'Account Fields';
        buttonName = 'Contact Fields';
        jumpToFunction = this.handleJumpToContacts;
        break;
      case RECORD_LEVEL_TYPE_CONTACT:
        SIMPLE_FIELDS_MAP = this.filterSimple(CONTACT_SKU_FIELDS_MAP);
        ADVANCED_FIELDS_MAP = this.filterAdvanced(CONTACT_SKU_FIELDS_MAP);
        tableRef = 'contactTable';
        tableHeader = 'Contact Fields';
        buttonName = 'Account Fields';
        jumpToFunction = this.handleJumpToCompanies;
        break;
      case RECORD_LEVEL_TYPE_ITEM:
        SIMPLE_FIELDS_MAP = this.filterSimple(ITEM_SKU_FIELDS_MAP);
        ADVANCED_FIELDS_MAP = this.filterAdvanced(ITEM_SKU_FIELDS_MAP);
        tableRef = 'itemTable';
        tableHeader = 'Item Fields';
        break;
      default:
        break;
    }

    const DISPLAY_GROUPED_FIELDS_MAP = this.groupAdvancedParams(
      ADVANCED_FIELDS_MAP,
      'displayGroup'
    );

    return (
      <div
        className="m-b-2"
        ref={node => {
          this[tableRef] = node;
        }}
      >
        {showButton ? (
          <button
            type="button"
            className="btn btn-secondary escape pull-right"
            onClick={jumpToFunction}
          >
            Jump To {buttonName}
          </button>
        ) : null}
        <h1 className="m-b-1">{tableHeader}</h1>
        {SIMPLE_FIELDS_MAP && SIMPLE_FIELDS_MAP.size > 0 ? (
          <div className="m-b-1">
            <h4>Simple Search</h4>
            {this.renderTable(SIMPLE_FIELDS_MAP)}
          </div>
        ) : null}
        {DISPLAY_GROUPED_FIELDS_MAP && DISPLAY_GROUPED_FIELDS_MAP.size > 0 ? (
          <div className="m-b-1">
            <h4>Advanced Search</h4>
            {this.renderAdvancedDisplayGroups(DISPLAY_GROUPED_FIELDS_MAP)}
          </div>
        ) : null}
      </div>
    );
  };

  render() {
    const { dialog, closeDialogFunction, currentSku } = this.props;
    let title = 'Preview SKU';

    // Set up title if we're previewing a group
    if (currentSku.setType === FIELDSET_TYPE_GROUP) {
      title = 'Preview Group';
    }

    return (
      <DialogForm
        cancelFunction={closeDialogFunction}
        cancelText="Close"
        content={this.renderPreview()}
        id="PreviewSkuDialog"
        modalClassName="info-dialog"
        show={dialog.show}
        title={title}
      />
    );
  }
}
